
export class CustomersRequest {
    
    country: string;
    nationalId: string;

	constructor() {
		
	}
}
